import { FC } from 'react';
import { Button } from 'antd';
import { TbCircleArrowUp, TbMailShare } from 'react-icons/tb';

import { PLAN_CONFIG, PlanKey } from '@/constants';

export interface CheckoutButtonProps {
    disabled?: boolean;
    loading: boolean;
    onCheckout: () => void;
    plan: PlanKey;
}

const CheckoutButton: FC<CheckoutButtonProps> = ({ disabled, loading, onCheckout, plan }): JSX.Element => {
    const isEnterprise = plan === 'enterprise';

    return (
        <Button
            block
            disabled={disabled}
            loading={loading}
            onClick={onCheckout}
            style={{ marginTop: '1rem' }}
            type={isEnterprise ? 'dashed' : 'primary'}
        >
            {isEnterprise ? (
                <>
                    Request Trial
                    <TbMailShare style={{ marginLeft: 6, verticalAlign: '-0.125rem' }} />
                </>
            ) : (
                <>
                    <TbCircleArrowUp style={{ marginRight: 6, verticalAlign: '-0.125rem' }} />
                    Upgrade to {PLAN_CONFIG[plan].label}
                </>
            )}
        </Button>
    );
};

export default CheckoutButton;
